import { useEffect, useState } from 'react';

/**
 * 輸入法組字（注音、拼音、日文）期間停住的值：組字中維持組字前的值，組完才跟上輸入框。
 *
 * 搜尋框的 onChange 在組字途中也會觸發（例如「ㄘㄜˋ」「かんじ」），直接拿去 debounce 的話，
 * 組字時停頓超過 debounce 時間就會把未完成的字送出搜尋、寫進網址。
 * 各瀏覽器 compositionend 與最後一次 input 事件的先後不同，兩種順序最後都會等於組完的值。
 *
 * @param {string} value 輸入框目前的值
 * @returns {{ settledValue: string, compositionProps: { onCompositionStart: Function, onCompositionEnd: Function } }}
 *   settledValue：組字中不變的值；compositionProps：展開到輸入框上
 */
export function useCompositionSettledValue(value) {
  const [isComposing, setIsComposing] = useState(false);
  const [settledValue, setSettledValue] = useState(value);

  useEffect(() => {
    if (!isComposing) {
      setSettledValue(value);
    }
  }, [value, isComposing]);

  const compositionProps = {
    onCompositionStart: () => setIsComposing(true),
    onCompositionEnd: () => setIsComposing(false),
  };

  return { settledValue, compositionProps };
}
